/**
 * ERP Checklists Tab Component
 * Emergency response checklists and procedures
 */

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { FileText, Sparkles } from 'lucide-react';
import { EMERGENCY_TYPES } from './ERPDashboardTab';

export default function ERPChecklistsTab({ 
  checklists,
  onSelectChecklist,
  onSeedDefaults
}) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {checklists.map(checklist => {
          const config = EMERGENCY_TYPES[checklist.emergency_type] || EMERGENCY_TYPES.other;
          return (
            <Card 
              key={checklist.id} 
              className="bg-slate-800/50 border-slate-700 cursor-pointer hover:border-slate-600"
              onClick={() => onSelectChecklist(checklist)}
            >
              <CardHeader className="pb-2">
                <div className="flex items-start justify-between">
                  <div className={`p-2 rounded-lg bg-${config.color}-500/20`}>
                    <config.icon className={`w-5 h-5 text-${config.color}-400`} />
                  </div>
                  {checklist.is_system && <Badge variant="outline" className="text-xs">System</Badge>}
                </div>
                <CardTitle className="text-white text-lg mt-2">{checklist.name}</CardTitle>
                <CardDescription className="line-clamp-2">{checklist.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-slate-400">{checklist.items?.length || 0} steps</span>
                  <Badge className={`bg-${config.color}-500/20 text-${config.color}-300`}>
                    {checklist.response_level?.replace('_', ' ')}
                  </Badge>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
      
      {checklists.length === 0 && (
        <Card className="bg-slate-800/50 border-slate-700">
          <CardContent className="p-8 text-center">
            <FileText className="w-12 h-12 text-slate-600 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-white mb-2">No Checklists Found</h3>
            <p className="text-slate-400 mb-4">Click "Seed Checklists" to add default emergency procedures</p>
            <Button onClick={onSeedDefaults}>
              <Sparkles className="w-4 h-4 mr-2" /> Seed Default Checklists
            </Button>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
